import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=c24191b2&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=c24191b2&prod&scoped=true&lang=css&external"
import style1 from "./Orders.vue?vue&type=style&index=1&id=c24191b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24191b2",
  null
  
)

export default component.exports